/* eslint-disable */
import React, { useContext, useMemo, useState } from "react";

import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//import translation function for language translation
import { useTranslation } from 'react-i18next';

//import context
import { GlobalProvider } from "context/GlobalContext";

/* importing installations data  */
import installations from '../../data/Installations.json';

const InstallationsBody = ({ downloadExcel }) => {
  const { screenHeight } = useContext(GlobalProvider);
  const { t } = useTranslation(); //for translation
  const [rowSelection, setRowSelection] = useState({});

  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const exportExcel = () => {
    const exportData = installations;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Installations.xlsx");
  };

  /* custom address HTML */
  const addressHTML = ({ dataItem }) => {
    return (
      <div className="">
        <p className="d-flex gap-2 align-items-center text-nowrap">
          <span className="d-block material-icons-outlined icon-md">
            pin_drop
          </span>
          <span className="d-block">{dataItem.address}</span>
        </p>
      </div>
    );
  };

  /* custom city HTML */
  const cityHTML = ({ dataItem }) => {
    return (
      <div className="">
        <p className="d-flex gap-2 align-items-center text-nowrap">
          <span className="d-block material-icons-outlined icon-md">
            pin_drop
          </span>
          <span className="d-block">{dataItem.city}</span>
        </p>
      </div>
    );
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Name"),
        size: 200,
      },
      {
        id: "responsibleUser",
        accessorKey: "responsibleUser",
        header: t("Responsible User"),
        size: 200,
      },
      {
        id: "address",
        accessorKey: "address",
        header: t("Address"),
        Cell: ({ row }) => addressHTML({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "city",
        accessorKey: "city",
        header: t("City"),
        Cell: ({ row }) => cityHTML({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "latitude",
        accessorKey: "latitude",
        header: t("Map Latitude"),
        size: 200,
      },
      {
        id: "longitude",
        accessorKey: "longitude",
        header: t("Map Longitude"),
        size: 200,
      },
    ],
    [t]
  );

  /* hook to hit  exportExcel() function*/
  React.useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  return (
    <div className="activity_table">
      <div className="table-responsive">
        {/* ========= MaterialReactTable start ======= */}
        <MaterialReactTable
          columns={tableColumns}
          data={installations}
          enableSorting
          enableFilters
          enableGlobalFilter={false}
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          state={{ rowSelection }}
          muiTableContainerProps={{ 
            sx: { 
              maxHeight: screenHeight,
              overflow: 'auto'
            } 
          }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
          muiTableHeadCellProps={{ 
            title: "",
            sx: {
              position: 'sticky',
              top: 0,
              zIndex: 1,
              backgroundColor: 'white'
            }
          }}
          initialState={{
            pagination: { pageSize: 100, pageIndex: 0 },
            showColumnFilters: true,
          }}
        />
        {/* ========= MaterialReactTable end ======= */}
      </div>
    </div>
  );
};

export default InstallationsBody;
